export interface EnvConfig {
    navigationEndpoint: string;
    homeUrl: { trumpf: string; mytrumpf: string };
    clientId: string;
    scope: string;
    salesforceApi: {
        baseUrl: string;
        apiVersion: string;
    };
}
export type Env = "prod" | "qa" | "dev";
export type EnvConfigs = Record<Env, EnvConfig>;

export const authClientName = "sf-page-header";
const clientId =
    "3MVG9vE7x_jtom6Y6lse7GE.fT9NBbmMvXl_CVmBzh8kJYvyPcEbYkJAN62lolFTs2YAotob7c5NSXdKYvhn5";
const scope = "openid api";
const salesforceApi = {
    baseUrl: "https://account-s.trumpf.com",
    apiVersion: "63.0",
};

export const envConfigs: EnvConfigs = {
    prod: {
        navigationEndpoint:
            "https://www.trumpf.com/api/default/menu/1.0/main-menu",
        homeUrl: {
            trumpf: "https://www.trumpf.com",
            mytrumpf: "https://www.trumpf.com/mytrumpf",
        },
        clientId,
        scope,
        salesforceApi,
    },
    qa: {
        navigationEndpoint:
            "https://trumpf.com.cms.qa.tru/api/default/menu/1.0/main-menu",
        homeUrl: {
            trumpf: "https://trumpf.com.cms.qa.tru",
            mytrumpf: "https://trumpf.com.cms.qa.tru/mytrumpf",
        },
        clientId,
        scope,
        salesforceApi,
    },
    dev: {
        navigationEndpoint:
            "https://cms.trumpf.com.dev.tru/api/default/menu/1.0/main-menu",
        homeUrl: {
            trumpf: "https://cms.trumpf.com.dev.tru",
            mytrumpf: "https://cms.trumpf.com.dev.tru/mytrumpf",
        },
        clientId,
        scope,
        salesforceApi,
    },
};
